import { render, staticRenderFns } from "./FormularioProdutoDialog.vue?vue&type=template&id=7f256749&"
import script from "./FormularioProdutoDialog.vue?vue&type=script&lang=js&"
export * from "./FormularioProdutoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports